import { render, staticRenderFns } from "./HooksBrandView.vue?vue&type=template&id=2c8fc077&scoped=true"
import script from "./HooksBrandView.vue?vue&type=script&lang=js"
export * from "./HooksBrandView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8fc077",
  null
  
)

export default component.exports